module.exports = __webpack_public_path__ + "img/error.42577c7e.svg";